import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { KYMW2401Component } from './kymw2401.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { CreateNewPageService } from './api-services/create-new-page.service';

/**
 * ページテンプレート新規作成画面 モジュール設定クラス
 *
 * @export KYMW2401Module
 * @class KYMW2401Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    WjNavModule,
    WjInputModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW2401Component,
  ],
  providers: [
    CreateNewPageService,
  ],
})

export class KYMW2401Module { }
